import { Mutation } from "@apollo/react-components";
import { Button, Checkbox, Modal, notification } from "antd";
import { gql } from "apollo-boost";
import React, { Component } from "react";

const SET_DEFAULT_EXPORT_TEMPLATE = gql`
    mutation setDefaultExportTemplate($id: ID!, $isDefault: Boolean!) {
        setDefaultExportTemplate(id: $id, isDefault: $isDefault)
    }
`;

export default class UpdateDefaultTemplate extends Component {
    state = {
        loading: false,
        isDefault: false,
        open: false,
    };

    componentDidMount() {
        const { record } = this.props;
        const isDefault = record?.isDefault ;

        this.setState({ isDefault })
    }

    render() {
        const { record, refetch } = this.props;
        const { isDefault, open } = this.state;

        return (
            <Mutation mutation={SET_DEFAULT_EXPORT_TEMPLATE}>
                {(updateTemplate) => (
                    <>
                        <Button
                            onClick={() => {
                                this.setState((p) => ({ ...p, open: !p.open }));
                            }}
                        >
                            Set Default
                        </Button>
                        <Modal
                            title="Update Template"
                            onOk={() =>
                                this.handleSubmit(
                                    updateTemplate,
                                    refetch,
                                    record.id,
                                )
                            }
                            open={open}
                            onCancel={() => this.setState({ open: false })}
                        >
                            <Checkbox
                                children="Make this the default"
                                checked={isDefault}
                                onChange={(value) => {
                                    const isDefault = value.target.checked;
                                    this.setState({ isDefault });
                                }}
                            />
                        </Modal>
                    </>
                )}
            </Mutation>
        );
    }

    handleSubmit = (updateTemplate, refetch, id) => {
        if (!id) return;

        updateTemplate({
            variables: {
                id,
                isDefault: this.state.isDefault,
            },
        })
            .then(() => {
                this.setState({ open: false });

                notification.success({ message: "Update template success" });
                refetch && refetch();
            })
            .catch((error) => {
                notification.error({ message: error });
            });
    };
}
